export default __webpack_public_path__ + "static/media/footer.8272ca73.png";